import React from "react";
import {
  Blocks,
  getAlt,
  getImage,
  getSvg,
  getVideo,
} from "../components/Blocks";
import { Hero } from "../components/Hero";
import { PageLogo } from "../components/PageLogo";
import { GradientSpacer } from "../elements/GradientSpacer";
import Layout from "../layouts/Layout";

export const PageContent: React.FC<{
  page: Queries.PageFragment;
  corePath: string;
}> = ({ page, corePath }) => {
  const {
    pageLogo,
    title,
    pageCategory,
    heroImage,
    heroVideo,
    blocks,
    heroStatement,
    externalHeroVideo,
    noHero,
    showTitle,
  } = page;

  const useHero = !noHero;

  const realTitle = pageCategory?.length
    ? pageCategory[0]
    : heroStatement?.heading ?? title;

  const noHeroOnPage =
    noHero &&
    (blocks[0].__typename === "GraphCMS_ContentBlock"
      ? blocks[0].contentBlockType &&
        !["Hero", "SectionHero", "ComplexHero", "DynamicHero"].includes(
          blocks[0].contentBlockType,
        )
      : true);

  return (
    <Layout corePath={corePath}>
      {useHero && (
        <Hero
          image={getImage(heroImage)}
          video={getVideo(heroVideo)}
          externalVideoUrl={externalHeroVideo}
          alt={getAlt(heroImage, title)}
          title={showTitle ? realTitle : undefined}
          heading={heroStatement?.title}
          description={heroStatement?.description}
        />
      )}
      {noHeroOnPage && <GradientSpacer />}
      <PageLogo logo={getSvg(pageLogo)} />
      <Blocks blocks={blocks} page={page} />
    </Layout>
  );
};
